/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f2e85fbc6b26d63db926542bb6a28dd134c26c4d";
